import type { GivingInterval } from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useSubscriptionPlans = () => {
  const { t } = useTranslation();

  const locales: Record<GivingInterval, string> = useMemo(
    () => ({
      annually: t('Annually'),

      bi_weekly: t('Bi-weekly'),
      daily: t('Daily'),
      monthly: t('Monthly'),

      one_time: t('One time'),
      quarterly: t('Quarterly'),
      weekly: t('Weekly'),
    }),
    [t],
  );

  const options: Array<{ label: string; value: GivingInterval }> = useMemo(
    () =>
      Object.keys(locales)
        .filter((key): key is GivingInterval => key in locales)
        .map((item) => ({ label: locales[item], value: item })),
    [locales],
  );

  const changeIntervalToText = useCallback(
    (interval: GivingInterval) =>
      ({
        annually: '12 months',

        bi_weekly: '2 weeks',
        daily: 'day',
        monthly: '1 month',

        one_time: '',
        quarterly: '3 months',
        weekly: 'week',
      })[interval],
    [],
  );

  const getTranslate = useCallback((key: GivingInterval) => locales[key], [locales]);

  return useMemo(
    () => ({
      changeIntervalToText,
      getTranslate,
      options,
    }),
    [getTranslate, changeIntervalToText, options],
  );
};
